<template>
  <span
    class="inline-block px-[10px] py-[3px] rounded-full text-[12px] font-medium"
    :style="{ color: config.style.color, background: config.style.background }"
  >
    {{ config.label }}
  </span>
</template>

<script>
import { KATEGORI_STATUS } from '../constants/kategori'

export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      default: 'active',
    },
  },
  computed: {
    config() {
      return KATEGORI_STATUS[this.status] || KATEGORI_STATUS.inactive
    },
  },
}
</script>
